package com.gstechnovos.sanative.components.widgets

import androidx.compose.runtime.Composable
import com.gstechnovos.sanative.utils.LocalBreakpoint
import com.gstechnovos.sanative.utils.Res
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val SystemCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.White) // color-bg-surface
            .borderRadius(16.px) // radius-lg
            .border(1.px, LineStyle.Solid, Color.rgb(0xE2E8F0)) // color-border-subtle
            .maxWidth(600.px)
            .width(90.percent)
    }
}

@Composable
fun SystemMessageCard(
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    // Dynamically adjust padding based on the global breakpoint provider[cite: 7]
    val breakpoint = LocalBreakpoint.current
    val isDesktop = breakpoint >= Res.Breakpoints.MD

    Column(
        modifier = SystemCardStyle.toModifier()
            .padding(if (isDesktop) 48.px else 32.px) // Generous padding for cognitive breathing room[cite: 5]
            .then(modifier),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        content()
    }
}